// components/LSSF/PaymentHistory.jsx
import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { MdSearch, MdVisibility } from 'react-icons/md';

const PaymentHistory = () => {
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const limit = 20;

  const getPaymentHistory = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${base_url}/api/v1/ccavenue/payment-history`);
      setData(res.data.data);
      setFilteredData(res.data.data);
      const total = Math.ceil(res.data.data.length / limit);
      setTotalPages(total > 0 ? total : 1);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching payment history:', err);
      toast.error('Failed to fetch payment history');
      setLoading(false);
    }
  };

  useEffect(() => {
    getPaymentHistory();
  }, []);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredData(data);
    } else {
      const searchLower = searchTerm.toLowerCase();
      const filtered = data.filter(item => {
        return (
          (item.order_id && item.order_id.toLowerCase().includes(searchLower)) ||
          (item.tracking_id && item.tracking_id.toLowerCase().includes(searchLower)) ||
          (item.billing_name && item.billing_name.toLowerCase().includes(searchLower)) ||
          (item.billing_email && item.billing_email.toLowerCase().includes(searchLower)) ||
          (item.billing_tel && item.billing_tel.includes(searchLower))
        );
      });
      setFilteredData(filtered);
    }
    setPage(1);
  }, [searchTerm, data]);

  const viewDetails = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const paginatedData = filteredData.slice((page - 1) * limit, page * limit);

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header row d-flex justify-content-between align-items-center">
                <div className="col-md-6">
                  <h4 className="mb-0">Payment History</h4>
                </div>
                <div className="col-md-6">
                  <div className="input-group">
                    <span className="input-group-text">
                      <MdSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by order id, tracking id, name, email, phone..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered shadow-sm mt-3" cellPadding={5}>
                    <thead className="bg-light">
                      <tr>
                        <th>S.No.</th>
                        <th>Order ID</th>
                        <th>Tracking ID</th>
                        <th>Name</th>
                        <th>Amount</th>
                        <th>Payment Mode</th>
                        {/* <th>Status</th> */}
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          {[...Array(9)].map((_, i) => (
                            <td key={i}><Skeleton count={1} /></td>
                          ))}
                        </tr>
                      ) : paginatedData.length > 0 ? (
                        paginatedData.map((item, index) => (
                          <tr key={item.id}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td>{item.order_id}</td>
                            <td>{item.tracking_id || '-'}</td>
                            <td>{item.billing_name}</td>
                            <td>{item.currency} {item.amount}</td>
                            <td>{item.payment_mode || '-'}</td>
                            {/* <td>
                              <span className={`badge ${item.order_status === 'Success' ? 'bg-success' : 'bg-danger'}`}>
                                {item.order_status}
                              </span>
                            </td> */}
                            <td>{item.trans_date ? new Date(item.trans_date).toLocaleString() : '-'}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-info"
                                onClick={() => viewDetails(item)}
                              >
                                <MdVisibility size={18} />
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="text-center text-danger">
                          <td colSpan={9}>No payment records found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {filteredData.length > limit && (
                  <div className="d-flex justify-content-center align-items-center gap-3 mt-4">
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      disabled={page === 1}
                      onClick={() => setPage(page - 1)}
                    >
                      Previous
                    </button>
                    <span>Page {page} of {totalPages}</span>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      disabled={page === totalPages}
                      onClick={() => setPage(page + 1)}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* View Details Modal */}
      {showModal && selectedItem && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-info text-white">
                <h5 className="modal-title">Payment Details - {selectedItem.order_id}</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <strong>Order ID:</strong>
                    <p>{selectedItem.order_id}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Tracking ID:</strong>
                    <p>{selectedItem.tracking_id || 'Not available'}</p>
                  </div>
                  {/* <div className="col-md-6 mb-3">
                    <strong>Bank Ref No:</strong>
                    <p>{selectedItem.bank_ref_no || 'Not available'}</p>
                  </div> */}
                  {/* <div className="col-md-6 mb-3">
                    <strong>Status:</strong>
                    <p>
                      <span className={`badge ${selectedItem.order_status === 'Success' ? 'bg-success' : 'bg-danger'}`}>
                        {selectedItem.order_status}
                      </span>
                    </p>
                  </div> */}
                  <div className="col-md-6 mb-3">
                    <strong>Status Message:</strong>
                    <p>{selectedItem.status_message || 'Not available'}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Payment Mode:</strong>
                    <p>{selectedItem.payment_mode} {selectedItem.card_name ? `(${selectedItem.card_name})` : ''}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Amount:</strong>
                    <p>{selectedItem.currency} {selectedItem.amount}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Transaction Date:</strong>
                    <p>{selectedItem.trans_date ? new Date(selectedItem.trans_date).toLocaleString() : 'Not available'}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Billing Name:</strong>
                    <p>{selectedItem.billing_name}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Billing Email:</strong>
                    <p>{selectedItem.billing_email}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Billing Phone:</strong>
                    <p>{selectedItem.billing_tel}</p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Billing Address:</strong>
                    <p>
                      {selectedItem.billing_address}, {selectedItem.billing_city},{' '}
                      {selectedItem.billing_state} - {selectedItem.billing_zip}, {selectedItem.billing_country}
                    </p>
                  </div>
                  <div className="col-md-6 mb-3">
                    <strong>Record Created:</strong>
                    <p>{new Date(selectedItem.created_at).toLocaleString()}</p>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default PaymentHistory;